import IndexPage from 'flarum/forum/components/IndexPage';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';

export default class CoursePage extends IndexPage {
  oninit(vnode) {
    Page.prototype.oninit.call(this, vnode);
    this.bodyClass = 'App--index';
  }

  hero() {
    const hidden = app.forum.attribute('taroCourseHeroHidden') || false;
    if (hidden) return null;
    const subtitle = app.forum.attribute('taroCourseHeroSubtitle') || '从零开始，进入塔罗的世界';
    const icon = app.forum.attribute('taroCourseHeroIcon') || 'fas fa-book-open';
    const color = app.forum.attribute('taroCourseHeroColor') || '';
    return (
      <header className="Hero" style={color ? { '--hero-bg': color } : undefined}>
        <div className="container">
          <h1 className="Hero-title">
            <i className={icon} style={{ marginRight: '8px' }} />
            新手启迪
          </h1>
          {subtitle ? <div className="Hero-subtitle">{subtitle}</div> : null}
        </div>
      </header>
    );
  }

  contentItems() {
    const items = new ItemList();
    items.add('content', <div className="CoursePage">S0 Course Page Placeholder</div>, 100);
    return items;
  }
}